const Reflux = require('@muzzylane/reflux');
const uuid = require('uuid');

const _ = {
    clone:      require('lodash/clone'),
    cloneDeep:  require('lodash/cloneDeep'),
    filter:     require('lodash/filter'),
    find:       require('lodash/find'),
    findIndex:  require('lodash/findIndex'),
    assign:     require('lodash/assign'),
    without:    require('lodash/without'),
    includes:   require('lodash/includes'),
    isEmpty:    require('lodash/isEmpty'),
    remove:     require('lodash/remove'),
    forEach:    require('lodash/forEach'),
    reject:     require('lodash/reject'),
};

const Globals = require('../../../app/globals');
const ShortCourseConstants = require('../../../app/shared/ShortCourseConstants');

const ShortCourseEditorActions = require('../actions/ShortCourseEditorActions');

let shortCourseDoc = {};
let selectedNodeId = null;
let currentNav = null; // {type: ShortCourseConstants.NAV_TYPES.Settings};
let selectedCommentTopicID = null;
let nodeSearchText = '';

let action = {};
let initialized = false;

const ShortCourseEditorStore = Reflux.createStore({
    listenables: [ShortCourseEditorActions],
    init: function() {},

    resetState: function() {
        shortCourseDoc = {};
        initialized = false;
        currentNav = null;
        selectedCommentTopicID = null;
        nodeSearchText = '';
    },

    getState: function() {
        return {
            shortCourseDoc,
            selectedNodeId,
            currentNav,selectedCommentTopicID, nodeSearchText, // state for side tabs
            initialized,
            action,
        };
    },

    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
    },
    
    applyConversions: function(inputDoc) {
        if (!inputDoc.client_content) {
            console.log("ERROR: missing client_content");
            return inputDoc; // no change
        }
        let anyChange = false;
        let client_content = _.cloneDeep(inputDoc.client_content);
        if (typeof client_content.coach_scripts === 'undefined') { // conversion for redmine #6017
            anyChange = true;

            // add entries for special tables
            client_content.customTables = {};
            _.forEach(ShortCourseConstants.TABLE_TEMPLATES,(tableTemplate)=>{
                client_content.customTables[tableTemplate.name] = _.cloneDeep(tableTemplate); // Note: name and key are identical
            });

            // convert rich text entries to an array
            client_content.rich_texts = [];
            let richTextMap = {};

            _.forEach(ShortCourseConstants.COACH_TEXTS, (staticCoachEntry)=>{
                let rich_text = client_content[staticCoachEntry.id] || staticCoachEntry.defaultText;
                delete client_content[staticCoachEntry.id];
                if (!rich_text) {
                    return;
                }
                let coach_script_id = staticCoachEntry.common ? null : staticCoachEntry.id;
                let richTextEntry = {
                    id: 'rt-' + uuid.v4(),
                    displayName: staticCoachEntry.displayName,
                    rich_text: rich_text,
                    coach_script_id, // if null, it can be used by multiple scripts and edited outside the coach script editor
                };
                client_content.rich_texts.push(richTextEntry);
                richTextMap[staticCoachEntry.id] = richTextEntry.id;
            });

            // convert stickers, and remember first sticker as a default for the coach scripts
            client_content.coach_stickers = [];
            let stickerMap = {};
            let defaultStickerId = null;
            let poseIndex = 1;
            _.forEach(client_content.sticker,(src,id)=>{
                if (src) {
                    let textEntry = _.find(ShortCourseConstants.COACH_TEXTS,{id});
                    // let displayName = 'Pose';
                    let displayName;
                    let specialPurpose = null;
                    if (!textEntry) {
//                        if (id === 'lower_sticker_shape') {
//                            specialPurpose = id;
//                        }
//                        else {
                            console.log(`discarding ${id}`, src);
                            return; // forget upper_sticker_shape
//                        }
//                        textEntry = _.find(ShortCourseConstants.SPECIAL_STICKERS,{id});
//                        if (!textEntry) {
//                            console.log("ERROR: didn't find key for sticker:",id);
//                            return;
//                        }
//                        displayName = textEntry.displayName;
                    }
                    else {
                        displayName = `Pose ${poseIndex}`;
                        poseIndex++;
                    }
                    let stickerEntry = {
                        id: 'sticker-' + uuid.v4(),
                        displayName: displayName,
                        src: src,
                        specialPurpose: specialPurpose,
                    };
                    client_content.coach_stickers.push(stickerEntry);
                    stickerMap[id] = stickerEntry.id;
                    if (!defaultStickerId && !specialPurpose) {
                        defaultStickerId = stickerEntry.id;
                    }
                }
            });
//            // make sure 'lower_sticker_shape' entry exists
//            if (!stickerMap['lower_sticker_shape']) {
//                let stickerEntry = {
//                    id: 'sticker-' + uuid.v4(),
//                    displayName: "Lower Partial Shape",
//                    src: '',
//                    specialPurpose: 'lower_sticker_shape',
//                };
//                client_content.coach_stickers.push(stickerEntry);
//            }
            delete client_content.sticker;
            
            // create coach scripts
            client_content.coach_scripts = _.cloneDeep(ShortCourseConstants.COACH_SCRIPTS);
            _.forEach(client_content.coach_scripts,(scriptEntry)=>{
                _.forEach(scriptEntry.actions,(actionEntry)=>{
                    if (actionEntry.coach_sticker_id) {
                        actionEntry.coach_sticker_id = stickerMap[actionEntry.coach_sticker_id] || defaultStickerId;
                    }
                    if (actionEntry.rich_text_id) {
                        actionEntry.rich_text_id = richTextMap[actionEntry.rich_text_id] || null;
                    }
                });
            });
        }
        else {
            // see if there are any missing coach scripts (for transitional content)
            _.forEach(ShortCourseConstants.COACH_SCRIPTS,(staticCoachEntry,cs_index)=>{
                if (!staticCoachEntry.id) {
                    console.error(`COACH_SCRIPTS[${cs_index}] missing id`,staticCoachEntry);
                }
                let scriptEntry = _.find(client_content.coach_scripts,{id:staticCoachEntry.id});
                if (!scriptEntry) {
                    anyChange = true;
                    console.log("adding missing coach script ",staticCoachEntry.id);
                    scriptEntry = _.cloneDeep(staticCoachEntry);
                    client_content.coach_scripts.push(scriptEntry);
                    _.forEach(scriptEntry.actions,(actionEntry)=>{
                        if (actionEntry.coach_sticker_id) {
                            actionEntry.coach_sticker_id = null;
                        }
                        if (actionEntry.rich_text_id) {
                            const staticRichTextEntry = _.find(ShortCourseConstants.COACH_TEXTS,{id: actionEntry.rich_text_id});
                            let richTextEntry = {
                                id: 'rt-' + uuid.v4(),
                                displayName: staticCoachEntry.displayName,
                                rich_text: staticRichTextEntry ? staticRichTextEntry.defaultText : '',
                                coach_script_id: staticCoachEntry.id,
                            };
                            client_content.rich_texts.push(richTextEntry);
                            actionEntry.rich_text_id = richTextEntry.id;
                        }
                    });
                }
            });

            // see if there is any missing report card rich text
            _.forEach(ShortCourseConstants.COACH_TEXTS, (staticRichTextEntry,rti)=>{
                if (!staticRichTextEntry.id) {
                    console.error(`COACH_TEXTS[${rti}] missing id`, staticRichTextEntry);
                }
                if (staticRichTextEntry.reportCard) {
                    if (typeof staticRichTextEntry.phase === 'undefined') {
                        console.warn("skipping invalid staticRichTextEntry");
                        return;
                    }
                    let x = _.find(client_content.rich_texts,{reportCard: true, phase: staticRichTextEntry.phase});
                    if (!x) {
                        console.log("adding missing report card text");
                        anyChange = true;
                        let richTextEntry = {
                            id: 'rt-' + uuid.v4(),
                            displayName: staticRichTextEntry.displayName,
                            rich_text: staticRichTextEntry.defaultText || '',
                            coach_script_id: null, // this can be edited in the common rich text place
                            reportCard: true,
                            phase: staticRichTextEntry.phase,
                        };
                        client_content.rich_texts.push(richTextEntry);
                    }
                }
            });
        }
        if (anyChange) {
            let outputDoc = {...inputDoc, client_content:client_content};
            return outputDoc;
        }
        return inputDoc;
    },

    onInitializeEditorDoc: function(actionId, doc, activities) {
        action = { id: actionId, name: 'initializeEditorDoc', doc, activities };
        if (!doc) {
            action.error = `missing doc`;
        }
        else {
            shortCourseDoc = _.cloneDeep(doc);
            shortCourseDoc = this.applyConversions(shortCourseDoc);
            
            if (shortCourseDoc.nodes.length === 0) {
                // there must be a completion node
                shortCourseDoc.nodes.push({
                    node_id: ShortCourseConstants.CompletionNodeID, 
                    prereq_node_ids: [],
                    name: 'Completion Node',
                    description: '',
                    allows_date: false,
					capstone: true, // identifies capstone to server
                    rsd_id: null,
                });
            }
			else {
				// set capstone flag for capstone (if node was created before capstone flag existed)
				let capstoneNode = _.find(shortCourseDoc.nodes,{node_id: ShortCourseConstants.CompletionNodeID});
				if (capstoneNode && !capstoneNode.capstone) {
					capstoneNode.capstone = true;
				}
			}
			
            if (typeof shortCourseDoc.nextNodeId !== 'number') {
                // determine nextNodeId
                shortCourseDoc.nextNodeId = shortCourseDoc.nodes.length;
                _.forEach(shortCourseDoc.nodes,(node)=>{
                    if (node.node_id.indexOf('sk') === 0) {
                        try {
                            let n = Number(node.node_id.slice(2));
                            shortCourseDoc.nextNodeId = Math.max(shortCourseDoc.nextNodeId,n+1);
                        }
                        catch(e) {
                            console.debug(e);
                        };
                    }
                });
            }
            
            // update to latest published version NOW DONE BY ContentUpdater
            
            initialized = true;
        }
        this.emitStatus();
    },
    
    onUpdateActivityVersion: function(actionId, nova_activity_id,version) {
        action = { id: actionId, name: 'updateActivityVersion', nova_activity_id, version };
        _.forEach(shortCourseDoc.content_blocks,(cb)=>{
            if ((cb.nova_activity_id === nova_activity_id) && (cb.activity_version != version)) {
                cb.activity_version = version;
            }
        });
        this.emitStatus();
    },
    
    onAddPrereq: function(actionId, node_id,prereq_id) {
        action = { id: actionId, name: 'addPrereq', node_id, prereq_id };
        let node = _.find(shortCourseDoc.nodes,{node_id});
        let preNode = _.find(shortCourseDoc.nodes,{node_id:prereq_id});
        if (node && preNode) {
            if (node_id === prereq_id) {
                action.error = `addPrereq cannot set ${node_id} as a prerequisite of itself.`;
            }
            else if (node.prereq_node_ids.indexOf(prereq_id) < 0) {
                node.prereq_node_ids = node.prereq_node_ids.concat(prereq_id);
            }
            else {
                action.error = `addPrereq warning: ${prereq_id} already a prerequisite of ${node_id}.`;
            }
        }
        else {
            if (!node) {
                action.error = `addPrereq didn't find node_id ${node_id}`;
            }
            if (!preNode) {
                action.error = `addPrereq didn't find node_id ${prereq_id}`;
            }
        }
        this.emitStatus();
    },

    onRemovePrereq: function(actionId, node_id,prereq_id) {
        action = { id: actionId, name: 'removePrereq', node_id, prereq_id };
        let node = _.find(shortCourseDoc.nodes,{node_id:node_id});
        if (node) {
            if (node.prereq_node_ids.indexOf(prereq_id) >= 0) {
                node.prereq_node_ids = _.without(node.prereq_node_ids,prereq_id);
            }
            else {
                action.error = `removePrereq warning: ${prereq_id} was not a prerequisite of ${node_id}.`;
            }
        }
        else {
            action.error = `removePrereq didn't find node_id ${node_id}`;
        }
        this.emitStatus();
    },

    onSetNodePosition: function(actionId, node_id,position) {
        action = { id: actionId, name: 'setNodePosition', node_id, position };
        let node = _.find(shortCourseDoc.nodes,{node_id});
        if (node) {
            node.position = position;
        }
        else {
            action.error = `setNodePosition didn't find node_id ${node_id}`;
        }
        this.emitStatus();
    },

    onAddSkillNode: function(actionId,capstone) {
        let newNodeId = `sk` + shortCourseDoc.nextNodeId;
        action = { id: actionId, name: 'addSkillNode', newNodeId };
        shortCourseDoc.nodes = shortCourseDoc.nodes.concat({
            node_id: newNodeId, 
            //type: ShortCourseConstants.NODE_TYPES.SkillNode,
            name: capstone ? 'Completion' : `Skill Node ${shortCourseDoc.nextNodeId}`,
            description: '',
            prereq_node_ids: [],
            allows_date: false,
			capstone: !!capstone,
            rsd_id: null,
        });
        shortCourseDoc.nextNodeId++;
        this.emitStatus();
    },
    
    onDeleteSkillNode: function(actionId, node_id) {
        action = { id: actionId, name: 'deleteSkillNode', node_id };
        let node = _.find(shortCourseDoc.nodes,{node_id});
        if (!node) {
            action.error = `${action.name} didn't find node_id ${node_id}`;
        }
        else {
            shortCourseDoc.nodes = _.without(shortCourseDoc.nodes,node);
            _.forEach(shortCourseDoc.nodes,(n,ni)=>{
                if (n.prereq_node_ids.indexOf(node_id) >= 0) {
                    let prereq_node_ids = _.without(n.prereq_node_ids,node_id);
                    shortCourseDoc.nodes[ni] = {...n, prereq_node_ids: prereq_node_ids};
                }
            });
            let content_blocks = [];
            _.forEach(shortCourseDoc.content_blocks,(cb,i)=>{
                if (cb.node_relations[node_id]) { 
                    delete cb.node_relations[node_id];
                    if (!_.isEmpty(cb.node_relations)) {
                        content_blocks.push(cb);
                    }
                }
                else {
                    content_blocks.push(cb);
                }
            });
            shortCourseDoc.content_blocks = content_blocks;

            let subskills = [];
            _.forEach(shortCourseDoc.subskills,(ss,i)=>{
                if (ss.node_id === node_id) {
                    // discard this subskill
                }
                else if (ss.node_relations && ss.node_relations[node_id]) {
                    delete ss.node_relations[node_id];
                    subskills.push(ss);
                }
                else {
                    subskills.push(ss);
                }
            });
            shortCourseDoc.subskills = subskills;

            if (selectedNodeId === node_id) {
                selectedNodeId = null;
            }
        }
        this.emitStatus();
    },

    onSelectNode: function(actionId, node_id) {
        action = { id: actionId, name: 'selectNode', node_id };
        selectedNodeId = node_id || null;
        currentNav = { type: ShortCourseConstants.NAV_TYPES.Node, id: node_id };
        this.emitStatus();
    },
    
    determineNodeType: function(node) {
		return node.capstone ? ShortCourseConstants.NODE_TYPES.CompletionNode : ShortCourseConstants.NODE_TYPES.SkillNode;
    },

    onSetNodeValue: function(actionId, node_id, key, value) {
        action = { id: actionId, name: 'setNodeValue', node_id, key, value };
        let ni = _.findIndex(shortCourseDoc.nodes,{node_id});
        let node = shortCourseDoc.nodes[ni];
        if (!node) {
            action.error = `setNodeValue didn't find node_id ${node_id}`;
            return this.emitStatus();
        }
        const nt = this.determineNodeType(node);
        let fieldTypes = ShortCourseConstants.simpleFieldTypes[nt];
        if (!fieldTypes) {
            action.error = `setNodeValue cannot be used for ${nt} node`;
            return this.emitStatus();
        }
        let ft = fieldTypes[key]; 
        if (!ft) {
            action.error = `setNodeValue cannot be used to set ${key} for ${nt} node`;
            return this.emitStatus();
        }
        node = _.clone(node);
        switch(ft) {
            case 'string':
                value = String(value);
                break;
            case 'number':
                value = Number(value);
                break;
        }
        node[key] = value;
        shortCourseDoc.nodes[ni] = node;
        this.emitStatus();
    },
    
    onSetNodeRSD: function(actionId, params) {
        let { node_id, rsd_service_id, rsd_id } = params;
        action = { id: actionId, name: 'setNodeRSD', params };
        let ni = _.findIndex(shortCourseDoc.nodes,{node_id});
        let node = shortCourseDoc.nodes[ni];
        if (!node) {
            action.error = `${action.name} didn't find node_id ${node_id}`;
            return this.emitStatus();
        }
        node = {...node,
            rsd_service_id,
            rsd_id
        };
        shortCourseDoc.nodes[ni] = node;
        this.emitStatus();
    },
	
    onAddContentBlock: function(actionId, params) {
        let { nova_activity_id, activity_version, activity_type, score_categories } = params;
        action = { id: actionId, name: 'addContentBlock', nova_activity_id, activity_version, activity_type };
        let cb = _.find(shortCourseDoc.content_blocks,{nova_activity_id});
        if (!cb) {
            action.hash = 'cb-' + uuid.v4();
            cb = {
                hash: action.hash,
                nova_activity_id,
                activity_version,
                type: Globals.short_course.content_block_type.ACTIVITY,
                node_relations: {},
                subskill_relations: {},
                activity_type: activity_type || Globals.short_course.REMEDIAL_ACTIVITY_TYPES[0],
            };
            shortCourseDoc.content_blocks = shortCourseDoc.content_blocks.concat(cb);
        }
        else {
            action.hash = cb.hash;
            if (cb.activity_version !== activity_version) {
                // we presume that the editor knows the latest version and the existing content block was out of date.
                console.log(`Updating content block ${cb.hash} activity_version to ${activity_version}`);
                cb.activity_version = activity_version;
            }
        }
        
        // see if there are any rsd_id matches
        if (score_categories) {
            _.forEach(shortCourseDoc.subskills,(ss)=>{
                if (ss.rsd_id) {
                    let cat = _.find(score_categories,{rsd_id: ss.rsd_id});
                    if (cat) {
                        console.log(`found matching rsd for ${cat.display_name}`);
                        cb.subskill_relations[ss.hash] = {
                            cb_score_type: Globals.short_course.content_block_score_req_type.OBJECTIVE,
                            objective_name: cat.name,
                        }
                    }
                }
            });
        }
        
        this.emitStatus();
    }, // onAddContentBlock
	
    onAddChatbotContentBlock: function(actionId, params) {
        let { node_id, chatbot_activity_hash, display_title, activity_type, subskill_relations, ...bot_options } = params;
        action = { id: actionId, name: 'addChatbotContentBlock', chatbot_activity_hash };
        let cb = _.find(shortCourseDoc.content_blocks,{chatbot_activity_hash});
        if (cb) {
            action.error = `${action.name} alread had chatbot_activity_hash ${chatbot_activity_hash}`;
            this.emitStatus();
            return;
        }
        action.hash = 'cb-' + uuid.v4();

        cb = {
            hash: action.hash,
            display_title,
            chatbot_activity_hash,
            type: Globals.short_course.content_block_type.CHATBOT,
            node_relations: {},
            subskill_relations,
            activity_type: activity_type || Globals.short_course.REMEDIAL_ACTIVITY_TYPES[0],
            bot_options,
        };
        if (node_id) {
            let ni = _.findIndex(shortCourseDoc.nodes,{node_id});
            let node = shortCourseDoc.nodes[ni];
            if (!node) {
                action.error = `${action.name} didn't find node_id ${node_id}`;
                this.emitStatus();
                return;
            }
//            if (cb.node_relations[node.node_id]) { // Note: this can't happen if we just added a content block.
//                action.error = `${action.name} already had content block relation for chatbot ${chatbot_activity_hash} and node_id ${node_id}`;
//                this.emitStatus();
//                return;
//            }
            cb.node_relations[node.node_id] = {
                activity_type: activity_type || Globals.short_course.REMEDIAL_ACTIVITY_TYPES[0],
            }
        }
        
        shortCourseDoc.content_blocks = shortCourseDoc.content_blocks.concat(cb);
        this.emitStatus();
    }, // addChatbotContentBlock
    
    onUpdateChatbotContentBlock: function(actionId, params) {
        let { node_id, chatbot_activity_hash, display_title, activity_type, subskill_relations, ...bot_options } = params;
        let cb = _.find(shortCourseDoc.content_blocks,{chatbot_activity_hash});
        if (!cb) {
            action.error = `${action.name} did not find chatbot_activity_hash ${chatbot_activity_hash}`;
            this.emitStatus();
            return;
        }
        if (node_id) {
            let ni = _.findIndex(shortCourseDoc.nodes,{node_id});
            let node = shortCourseDoc.nodes[ni];
            if (!node) {
                action.error = `${action.name} didn't find node_id ${node_id}`;
                this.emitStatus();
                return;
            }
            cb.node_relations[node.node_id] = {
                activity_type: activity_type || Globals.short_course.REMEDIAL_ACTIVITY_TYPES[0],
            }
        }
        
        cb.display_title = display_title;
        cb.activity_type = activity_type;
        cb.subskill_relations = subskill_relations;
        cb.bot_options = bot_options;
        this.emitStatus();
    },
    
    // TODO pick one version of onRemoveChatbotContentBlock
    onRemoveChatbotContentBlock: function(actionId, chatbot_activity_hash) {
        const query = {chatbot_activity_hash};
        if (!_.find(shortCourseDoc.content_blocks,query)) {
            action.error = `${action.name} did not find chatbot_activity_hash ${chatbot_activity_hash}`;
            this.emitStatus();
            return;
        }
        shortCourseDoc.content_blocks = _.without(shortCourseDoc.content_blocks,query);
        this.emitStatus();
    },

    // TODO pick one version of onRemoveChatbotContentBlock
    onRemoveChatbotContentBlock: function(actionId, chatbot_activity_hash) {
        action = { id: actionId, name: 'removeChatbotContentBlock', chatbot_activity_hash };
        let cb_query = { chatbot_activity_hash };
        let cb = _.find(shortCourseDoc.content_blocks,cb_query);
        if (!cb) {
            action.error = `${action.name} didn't find content block for chatbot_activity_hash ${chatbot_activity_hash}`;
            this.emitStatus();
            return;
        }
		_.remove(shortCourseDoc.content_blocks,cb_query);
        this.emitStatus();
    }, // onRemoveChatbotContentBlock
    
    onRemoveContentBlock: function(actionId, nova_activity_id) {
        action = { id: actionId, name: 'removeContentBlock', nova_activity_id };
        let cb_query = { nova_activity_id };
        let cb = _.find(shortCourseDoc.content_blocks,cb_query);
        if (!cb) {
            action.error = `${action.name} didn't find content block for activity ${nova_activity_id}`;
            this.emitStatus();
            return;
        }
		_.remove(shortCourseDoc.content_blocks,cb_query);
        this.emitStatus();
    }, // onRemoveContentBlockFromNode
    
    onAddContentBlockToNode: function(actionId, params) {
        let { node_id, nova_activity_id, activity_version, activity_type, score_categories} = params;
        action = { id: actionId, name: 'addContentBlockToNode', node_id, nova_activity_id, activity_version, activity_type };
        let ni = _.findIndex(shortCourseDoc.nodes,{node_id});
        let node = shortCourseDoc.nodes[ni];
        if (!node) {
            action.error = `${action.name} didn't find node_id ${node_id}`;
            this.emitStatus();
            return;
        }
        let cb = _.find(shortCourseDoc.content_blocks,{nova_activity_id});
        if (!cb) {
            action.hash = 'cb-' + uuid.v4();
            cb = {
                hash: action.hash,
                nova_activity_id,
                activity_version,
                type: Globals.short_course.content_block_type.ACTIVITY,
                node_relations: {},
                subskill_relations: {},
            };
            shortCourseDoc.content_blocks = shortCourseDoc.content_blocks.concat(cb);
        }
        else {
            action.hash = cb.hash;
            if (cb.activity_version !== activity_version) {
                // we presume that the editor knows the latest version and the existing content block was out of date.
                console.log(`Updating content block ${cb.hash} activity_version to ${activity_version}`);
                cb.activity_version = activity_version;
            }
        }
        if (cb.node_relations[node.node_id]) { // Note: this can't happen if we just added a content block.
            action.error = `${action.name} already had content block relation for activity ${nova_activity_id} and node_id ${node_id}`;
            this.emitStatus();
            return;
        }
        cb.node_relations[node.node_id] = {
            activity_type: activity_type || Globals.short_course.ASSESSMENT_ACTIVITY_TYPES[0],
        }
        
        // see if there are any rsd_id matches
        if (score_categories) {
            const node_subskills = _.filter(shortCourseDoc.subskills,(ss)=>(!!(ss.node_relations[node.node_id])));
            _.forEach(node_subskills,(ss)=>{
                if (ss.rsd_id) {
                    let cat = _.find(score_categories,{rsd_id: ss.rsd_id});
                    if (cat) {
                        console.log(`found matching rsd for ${cat.display_name}`);
                        cb.subskill_relations[ss.hash] = {
                            cb_score_type: Globals.short_course.content_block_score_req_type.OBJECTIVE,
                            objective_name: cat.name,
                        }
                    }
                }
            });
        }

        
        this.emitStatus();
    }, // onAddContentBlockToNode

    onRemoveContentBlockFromNode: function(actionId, node_id, nova_activity_id) {
        action = { id: actionId, name: 'removeContentBlockFromNode', node_id, nova_activity_id };
        let ni = _.findIndex(shortCourseDoc.nodes,{node_id});
        let node = shortCourseDoc.nodes[ni];
        if (!node) {
            action.error = `${action.name} didn't find node_id ${node_id}`;
            this.emitStatus();
            return;
        }
        let cb_query = { nova_activity_id };
        let cb = _.find(shortCourseDoc.content_blocks,cb_query);
        if (!cb) {
            action.error = `${action.name} didn't find content block for activity ${nova_activity_id}`;
            this.emitStatus();
            return;
        }
        if (!cb.node_relations[node.node_id]) {
            action.error = `${action.name} didn't find content block relation for activity ${nova_activity_id} and node_id ${node_id}`;
            this.emitStatus();
            return;
        }
        delete cb.node_relations[node.node_id];
        const node_subskills = _.filter(shortCourseDoc.subskills,(ss)=>(!!(ss.node_relations[node.node_id])));
        _.forEach(node_subskills,(ss)=>{
            delete cb.subskill_relations[ss.hash];
        });
        if (_.isEmpty(cb.node_relations) && _.isEmpty(cb.subskill_relations) && !cb.activity_type) {
            // delete the content block itself
            _.remove(shortCourseDoc.content_blocks,cb_query);
        }
        this.emitStatus();
    }, // onRemoveContentBlockFromNode

    onSetContentBlockValue: function(actionId, params) {
        action = { id: actionId, name: 'setContentBlockValue', ...params };
        let {node_id,nova_activity_id,key,value} = params;
        let cb_query = { nova_activity_id };
        let cb = _.find(shortCourseDoc.content_blocks,cb_query);
        if (!cb) {
            action.error = `${action.name} didn't find content block for activity ${nova_activity_id}`;
            this.emitStatus();
            return;
        }
        switch(key) {
            case 'activity_type': {
				if (value === null || (Globals.short_course.content_block_activity_types[value])) {
                    cb[key] = value;
                    this.emitStatus();
                    return;
                }
                action.error = `${action.name} unable to set content block ${key} to ${value} for activity ${nova_activity_id}`;
                this.emitStatus();
                return;
            }
            default:
                action.error = `${action.name} unable to set content block ${key} to ${value} for activity ${nova_activity_id}`;
                this.emitStatus();
                return;
            
        }
		
	},
	
    onSetContentBlockNodeValue: function(actionId, params) {
        action = { id: actionId, name: 'setContentBlockNodeValue', ...params };
        let {node_id,nova_activity_id,key,value} = params;
        let ni = _.findIndex(shortCourseDoc.nodes,{node_id});
        let node = shortCourseDoc.nodes[ni];
        if (!node) {
            action.error = `${action.name} didn't find node_id ${node_id}`;
            this.emitStatus();
            return;
        }
        let cb_query = { nova_activity_id };
        let cb = _.find(shortCourseDoc.content_blocks,cb_query);
        if (!cb) {
            action.error = `${action.name} didn't find content block for activity ${nova_activity_id}`;
            this.emitStatus();
            return;
        }
        if (!cb.node_relations[node.node_id]) { 
            action.error = `${action.name} didn't find node_relations for activity ${nova_activity_id} and node_id ${node_id}`;
            this.emitStatus();
            return;
        }
        switch(key) {
            case 'activity_type': {
				if (Globals.short_course.content_block_activity_types[value]) {
                    cb.node_relations[node.node_id][key] = value;
                    this.emitStatus();
                    return;
                }
                action.error = `${action.name} unable to set ${key} to ${value} for activity ${nova_activity_id} and node_id ${node_id}`;
                this.emitStatus();
                return;
            }
            
            default:
                action.error = `${action.name} unable to set ${key} to ${value} for activity ${nova_activity_id} and node_id ${node_id}`;
                this.emitStatus();
                return;
            
        }
    },

    onSetContentBlockSubskillValue: function(actionId, params) {
        action = { id: actionId, name: 'setContentBlockSubskillValue', ...params };
        let {ss_hash,nova_activity_id,key,value} = params;
        let ss_index = _.findIndex(shortCourseDoc.subskills,{hash:ss_hash});
        if (ss_index < 0) {
            action.error = `${action.name} didn't find subskill {ss_hash}`;
            return this.emitStatus();
        }
        let subskill = shortCourseDoc.subskills[ss_index];
        let cb_query = { nova_activity_id };
        let cb_index = _.findIndex(shortCourseDoc.content_blocks,cb_query)
        let cb = shortCourseDoc.content_blocks[cb_index];
        if (!cb) {
            action.error = `${action.name} didn't find content block for activity ${nova_activity_id}`;
            this.emitStatus();
            return;
        }
        switch(key) {
            case 'objective_name':
            {
                if (value === 'NONE') { // magic value
                    console.log(`Deleting subskill_relations for ${ss_hash}: ${JSON.stringify(cb.subskill_relations[ss_hash])}`); // FIXME: remove debug spam
                    delete cb.subskill_relations[ss_hash];
                }
                else {
                    if (!cb.subskill_relations[ss_hash]) {
                        cb.subskill_relations[ss_hash] = {
                        };
                    }
                    if (value === 'OVERALL') {
                        cb.subskill_relations[ss_hash].cb_score_type = Globals.short_course.content_block_score_req_type.OVERALL;
                        cb.subskill_relations[ss_hash].objective_name = null;
                    }
                    else {
                        cb.subskill_relations[ss_hash].cb_score_type = Globals.short_course.content_block_score_req_type.OBJECTIVE;
                        cb.subskill_relations[ss_hash].objective_name = value;
                    }
                }
                shortCourseDoc.content_blocks[cb_index] = _.cloneDeep(cb); // make sure react componenets know this changed
                this.emitStatus();
                return;
            }
            default:
                action.error = `${action.name} unable to set ${key} to ${value} for activity ${nova_activity_id}`;
                this.emitStatus();
                return;
        }
    },
    
    onSyncContentBlockSubskills: function(actionId, params) {
        action = { id: actionId, name: 'syncContentBlockSubskills', ...params };
        let {node_id, nova_activity_id, score_categories} = params;
        let node;
        if (node_id) {
            node = _.find(shortCourseDoc.nodes,{node_id});
            if (!node) {
                action.error = `${action.name} didn't find node_id ${node_id}`;
                return this.emitStatus();
            }
        }

        let cb = _.find(shortCourseDoc.content_blocks,{nova_activity_id});
        if (!cb) {
            action.error = `${action.name} unable to find content block for activity ${nova_activity_id}`;
            this.emitStatus();
            return;
        }
        
        // see if there are any rsd_id matches
        if (score_categories) {
            const subskills = node ? _.filter(shortCourseDoc.subskills,(ss)=>(!!(ss.node_relations[node.node_id]))) : shortCourseDoc.subskills;
            _.forEach(subskills,(ss)=>{
                if (ss.rsd_id) {
                    let cat = _.find(score_categories,{rsd_id: ss.rsd_id});
                    if (cat) {
                        console.log(`found matching rsd for ${cat.display_name}`);
                        cb.subskill_relations[ss.hash] = {
                            cb_score_type: Globals.short_course.content_block_score_req_type.OBJECTIVE,
                            objective_name: cat.name,
                        };
                    }
                }
            });
        }

        this.emitStatus();
    },

    onAddSubskill: function(actionId) {
        let new_ss_hash = `ss-` + uuid.v4();
        action = { id: actionId, name: 'addSubskill', new_ss_hash };
        if (_.find(shortCourseDoc.subskills,{hash: new_ss_hash})) {
            action.error = `${action.name} unexpected hash ${new_ss_hash} conflict`;
            return this.emitStatus();
        }
        shortCourseDoc.subskills = shortCourseDoc.subskills.concat({
            hash: new_ss_hash,
            display_name: `Subskill ${1+shortCourseDoc.subskills.length}`,
            node_relations: {},
        });
        this.emitStatus();
    },
    
    onDeleteSubskill: function(actionId, ss_hash) {
        action = { id: actionId, name: 'deleteSubskill', ss_hash };
        let ss_index = _.findIndex(shortCourseDoc.subskills,{hash:ss_hash});
        if (ss_index < 0) {
            action.error = `${action.name} didn't find subskill {ss_hash}`;
            return this.emitStatus();
        }
        let subskill = shortCourseDoc.subskills[ss_index];
		shortCourseDoc.subskills = shortCourseDoc.subskills.slice();
		shortCourseDoc.subskills.splice(ss_index,1);
		// remove subskill_relations entries
		_.forEach(shortCourseDoc.content_blocks,(cb,i)=>{
			delete cb.subskill_relations[ss_hash];
		});
        this.emitStatus();
    },

    onAddSubskillToNode: function(actionId, node_id) {
        let new_ss_hash = `ss-` + uuid.v4();
        action = { id: actionId, name: 'addSubskillToNode', node_id, new_ss_hash };
        let node = _.find(shortCourseDoc.nodes,{node_id});
        if (!node) {
            action.error = `${action.name} didn't find node_id ${node_id}`;
            return this.emitStatus();
        }
        if (_.find(shortCourseDoc.subskills,{hash: new_ss_hash})) {
            action.error = `${action.name} unexpected hash ${new_ss_hash} conflict`;
            return this.emitStatus();
        }
        
        let node_relations = {};
        node_relations[node_id] = { };
        let node_subskills = _.filter(shortCourseDoc.subskills,(ss)=>(!!(ss.node_relations[node_id])));
        shortCourseDoc.subskills = shortCourseDoc.subskills.concat({
            hash: new_ss_hash,
            display_name: `Subskill ${1+node_subskills.length}`,
            node_relations,
        });
        // add empty subskill_relations entry for all content blocks related to this node
//        _.forEach(shortCourseDoc.content_blocks,(cb,i)=>{
//            if (cb.node_relations[node_id]) {
//                cb.subskill_relations[new_ss_hash] = {};
//            }
//        });
        this.emitStatus();
    },
    
    onDeleteSubskillFromNode: function(actionId, node_id, ss_hash) {
        action = { id: actionId, name: 'deleteSubskill', node_id, ss_hash };
        let node = _.find(shortCourseDoc.nodes,{node_id});
        if (!node) {
            action.error = `${action.name} didn't find node_id ${node_id}`;
            return this.emitStatus();
        }
        let ss_index = _.findIndex(shortCourseDoc.subskills,{hash:ss_hash});
        if (ss_index < 0) {
            action.error = `${action.name} didn't find subskill {ss_hash}`;
            return this.emitStatus();
        }
        let subskill = shortCourseDoc.subskills[ss_index];
        if (!subskill.node_relations[node_id]) {
            action.error = `${action.name} didn't find node ${node_id} in subskill ${ss_hash}`;
            return this.emitStatus();
        }
        
        subskill = {... subskill}; // shallow clone
        delete subskill.node_relations[node_id];
        if (_.isEmpty(subskill.node_relations)) {
            shortCourseDoc.subskills = shortCourseDoc.subskills.slice();
            shortCourseDoc.subskills.splice(ss_index,1);
            // remove subskill_relations entries
            _.forEach(shortCourseDoc.content_blocks,(cb,i)=>{
                delete cb.subskill_relations[ss_hash];
            });
        }
        else {
            shortCourseDoc.subskills[ss_index] = subskill;
        }
        this.emitStatus();
    },

    onSetSubskillValue: function(actionId, ss_hash, key, value) {
        action = { id: actionId, name: 'setSubskillValue', ss_hash, key, value };
        let ss_index = _.findIndex(shortCourseDoc.subskills,{hash:ss_hash});
        if (ss_index < 0) {
            action.error = `${action.name} didn't find subskill {ss_hash}`;
            return this.emitStatus();
        }
        let ss = shortCourseDoc.subskills[ss_index];
        ss = {...ss}; // shallow clone
        switch(key) {
            case 'display_name':
            case 'description':
            case 'rsd_service_id':
            case 'rsd_id':
                ss[key] = value;
                break;
        }
        shortCourseDoc.subskills[ss_index] = ss;
        this.emitStatus();
    },

    onSetRichText: function(actionId, rich_text_id, richText) {
        action = { id: actionId, name: 'setRichText', rich_text_id, richText };
        let richTextEntry = _.find(shortCourseDoc.client_content.rich_texts,{id:rich_text_id});
        if (!richTextEntry) {
            action.error = `${action.name} didn't find rich_text_id ${rich_text_id}`;
            return this.emitStatus();
        }
        richTextEntry.rich_text = richText;
        this.emitStatus();
    },

    onSetRichTextTitle: function(actionId, rich_text_id, displayName) {
        action = { id: actionId, name: 'setRichTextTitle', rich_text_id, displayName };
        let richTextEntry = _.find(shortCourseDoc.client_content.rich_texts,{id:rich_text_id});
        if (!richTextEntry) {
            action.error = `${action.name} didn't find rich_text_id ${rich_text_id}`;
            return this.emitStatus();
        }
        richTextEntry.displayName = displayName;
        this.emitStatus();
    },


    onSetBackground: function(actionId, src) {
        action = { id: actionId, name: 'setBackground', src };

        shortCourseDoc.client_content.background_img = src;
        this.emitStatus();
    },

    _doCreateNewRichText: function(coach_script_id, rich_text_id, displayName) {
        if (!rich_text_id) {
            rich_text_id = 'rt-' + uuid.v4();
        }
        if (!displayName) {
            displayName = "New Coach Text";
        }
        return {
            id: rich_text_id,
            displayName,
            coach_script_id: coach_script_id || null,
            rich_text: ''
        };
    },
    
    onAddCoachRichText: function(actionId, coach_script_id, rich_text_id, displayName) {
        let richTextEntry = this._doCreateNewRichText(coach_script_id, rich_text_id, displayName);

        // in case these weren't specified, get them from the new entry
        rich_text_id = richTextEntry.rich_text_id;
        displayName = richTextEntry.displayName;
        
        action = { id: actionId, name: 'addCoachRichText', coach_script_id, rich_text_id, displayName};
        if (_.find(shortCourseDoc.client_content.rich_texts,{id:rich_text_id})) {
            action.error = `${action.name} already has rich_text_id ${rich_text_id}`;
            return this.emitStatus();
        }
        shortCourseDoc.client_content.rich_texts.push(richTextEntry);
        this.emitStatus();
    },

    onDeleteCoachRichText: function(actionId, rich_text_id) {
        action = { id: actionId, name: 'deleteCoachRichText', rich_text_id};
        let q = {id:rich_text_id};
        if (!_.find(shortCourseDoc.client_content.rich_texts,q)) {
            action.error = `${action.name} did not find rich_text_id ${rich_text_id}`;
            return this.emitStatus();
        }
        shortCourseDoc.client_content.rich_texts = _.reject(shortCourseDoc.client_content.rich_texts,q);
        this.emitStatus();
    },


    onAddSticker: function(actionId, coach_sticker_id, displayName) {
        if (!coach_sticker_id) {
            coach_sticker_id = 'sticker-' + uuid.v4();
        }
        if (!displayName) {
            displayName = "New Pose";
        }
        action = { id: actionId, name: 'addSticker', coach_sticker_id, displayName };
        if (_.find(shortCourseDoc.client_content.coach_stickers,{id:coach_sticker_id})) {
            action.error = `${action.name} already has coach_sticker_id ${coach_sticker_id}`;
            return this.emitStatus();
        }
        shortCourseDoc.client_content.coach_stickers = shortCourseDoc.client_content.coach_stickers.slice();
        shortCourseDoc.client_content.coach_stickers.push({
            id: coach_sticker_id,
            displayName,
            src: null
        });
        this.emitStatus();
    },

    onSetStickerSrc: function(actionId, coach_sticker_id, src) {
        action = { id: actionId, name: 'setStickerSrc', coach_sticker_id, src };
        let index = _.findIndex(shortCourseDoc.client_content.coach_stickers,{id:coach_sticker_id});
        if (index < 0) {
            action.error = `${action.name} did not find  coach_sticker_id ${coach_sticker_id}`;
            return this.emitStatus();
        }
        shortCourseDoc.client_content.coach_stickers[index].src = src; 
        this.emitStatus();
    },

    onSetStickerDisplayName: function(actionId, coach_sticker_id, displayName) {
        action = { id: actionId, name: 'setStickerDisplayName', coach_sticker_id, displayName };
        let index = _.findIndex(shortCourseDoc.client_content.coach_stickers,{id:coach_sticker_id});
        if (index < 0) {
            action.error = `${action.name} did not find  coach_sticker_id ${coach_sticker_id}`;
            return this.emitStatus();
        }
        shortCourseDoc.client_content.coach_stickers[index].displayName = displayName; 
        this.emitStatus();
    },

    onDeleteSticker: function(actionId, coach_sticker_id, displayName) {
        action = { id: actionId, name: 'addSticker', coach_sticker_id, displayName };
        if (!_.find(shortCourseDoc.client_content.coach_stickers,{id:coach_sticker_id})) {
            action.error = `${action.name} does not have coach_sticker_id ${coach_sticker_id}`;
            return this.emitStatus();
        }
        shortCourseDoc.client_content.coach_stickers = _.reject(shortCourseDoc.client_content.coach_stickers,{id:coach_sticker_id});
        this.emitStatus();
    },

    onSetMasteryScore: function(actionId, masteryScore) {
        action = { id: actionId, name: 'setMasteryScore', masteryScore };
        shortCourseDoc.mastery_score = masteryScore;
        this.emitStatus();
    },

    onSetPerfectScore: function(actionId, perfectScore) {
        action = { id: actionId, name: 'setPerfectScore', perfectScore };
        shortCourseDoc.perfect_score = perfectScore;
        this.emitStatus();
    },
    
    onSetTutorialScoreA2: function(actionId, tutorialScoreA2) {
        action = { id: actionId, name: 'onSetTutorialScoreA2', tutorialScoreA2 };
        shortCourseDoc.tutorial_score_a2 = tutorialScoreA2;
        this.emitStatus();
    },

    onSetTutorialScoreA3: function(actionId, tutorialScoreA3) {
        action = { id: actionId, name: 'onSetTutorialScoreA3', tutorialScoreA3 };
        shortCourseDoc.tutorial_score_a3 = tutorialScoreA3;
        this.emitStatus();
    },
    
    // badge_parameters: {
    //   issueBadge: <boolean>
    //   badge_template_id: integer
    // }
    onSetBadgeParameters: function(actionId, badge_parameters) {
        action = { id: actionId, name: 'setBadgeParameters', badge_parameters };
        shortCourseDoc.badge_parameters = badge_parameters;
        this.emitStatus();
    },
    
    onUpdateCoachScriptAction: function(actionId, coachScriptId, actionIndex, changes) {
        action = { id: actionId, name: 'updateCoachScriptAction', coachScriptId, actionIndex, changes };
        let index = _.findIndex(shortCourseDoc.client_content.coach_scripts,{id: coachScriptId});
        let coachScript = shortCourseDoc.client_content.coach_scripts[index];
        if (!coachScript) {
            action.error = `${action.name} did not find id ${coachScriptId}`;
            return this.emitStatus();
        }
        let coachAction = coachScript.actions[actionIndex];
        if (!coachAction) {
            action.error = `${action.name} id ${coachScriptId} did not find actionIndex ${actionIndex}`;
            return this.emitStatus();
        }
        shortCourseDoc.client_content.coach_scripts[index].actions[actionIndex] = {...coachAction,...changes };
        this.emitStatus();
    },
    
    onAddCoachScriptAction: function(actionId, coachScriptId, actionIndex) {
        action = { id: actionId, name: 'addCoachScriptAction', coachScriptId, actionIndex };
        let index = _.findIndex(shortCourseDoc.client_content.coach_scripts,{id: coachScriptId});
        let coachScript = shortCourseDoc.client_content.coach_scripts[index];
        if (!coachScript) {
            action.error = `${action.name} did not find id ${coachScriptId}`;
            return this.emitStatus();
        }
        // also add a new rich text element for the action
        let richTextEntry = this._doCreateNewRichText(coachScriptId);
        shortCourseDoc.client_content.rich_texts.push(richTextEntry);
        let newAction = {
            type: 'showRichText',  
            rich_text_id: richTextEntry.id,
            coach_sticker_id: null,
        };
        shortCourseDoc.client_content.coach_scripts[index].actions.push(newAction);
        this.emitStatus();
    },
    
    onMoveCoachScriptAction: function(actionId, coachScriptId, actionIndex, delta) {
        action = { id: actionId, name: 'moveCoachScriptAction', coachScriptId, actionIndex, delta };
        delta = Math.round(delta); // make sure it is an integer
        let index = _.findIndex(shortCourseDoc.client_content.coach_scripts,{id: coachScriptId});
        let coachScript = shortCourseDoc.client_content.coach_scripts[index];
        if (!coachScript) {
            action.error = `${action.name} did not find id ${coachScriptId}`;
            return this.emitStatus();
        }
        let coachAction = coachScript.actions[actionIndex];
        if (!coachAction) {
            action.error = `${action.name} id ${coachScriptId} did not find actionIndex ${actionIndex}`;
            return this.emitStatus();
        }
        let swapIndex = Math.round(actionIndex + delta);
        let swapAction = coachScript.actions[swapIndex];
        if ((swapIndex === actionIndex) || !swapAction) {
            action.error = `${action.name} id ${coachScriptId} actionIndex ${actionIndex} invalid delta ${delta}`;
            return this.emitStatus();
        }
        shortCourseDoc.client_content.coach_scripts[index].actions[actionIndex] = swapAction;
        shortCourseDoc.client_content.coach_scripts[index].actions[swapIndex] = coachAction;
        this.emitStatus();
    },

    onDeleteCoachScriptAction: function(actionId, coachScriptId, actionIndex) {
        action = { id: actionId, name: 'deleteCoachScriptAction', coachScriptId, actionIndex };
        let index = _.findIndex(shortCourseDoc.client_content.coach_scripts,{id: coachScriptId});
        let coachScript = shortCourseDoc.client_content.coach_scripts[index];
        if (!coachScript) {
            action.error = `${action.name} did not find id ${coachScriptId}`;
            return this.emitStatus();
        }
        let coachAction = coachScript.actions[actionIndex];
        if (!coachAction) {
            action.error = `${action.name} id ${coachScriptId} did not find actionIndex ${actionIndex}`;
            return this.emitStatus();
        }

        // this code would remove the rich text but we have an alternative UI which shows rich text associated with a coach script but not used in actions
        // TBD: how to move rich text from one coach script to another?
//        if (coachAction.rich_text_id) {
//            // delete associated rich text if it isn't common
//            let q = {id:coachAction.rich_text_id};
//            let richTextEntry = _.find(shortCourseDoc.client_content.rich_texts,q);
//            if (richTextEntry && (richTextEntry.coach_script_id === coachScriptId)) {
//                shortCourseDoc.client_content.rich_texts = _.reject(shortCourseDoc.client_content.rich_texts,q);
//            }
//        }

        shortCourseDoc.client_content.coach_scripts[index].actions.splice(actionIndex,1);
        this.emitStatus();
    },
    
    onChangeCriteriaScoresStyle: function(actionId, params) {
        action = { id: actionId, name: 'changeCriteriaScoresStyle', params };
        const priorStyle = shortCourseDoc.client_content.criteriaScoresStyle || {};
        let criteriaScoresStyle = { ...priorStyle };
        criteriaScoresStyle[params.key] = params.value;
        shortCourseDoc.client_content.criteriaScoresStyle = criteriaScoresStyle;
        this.emitStatus();
    },
    
    onChangeVoiceOptions: function(actionId, options) {
        action = { id: actionId, name: 'changeVoiceOptions', options };
        shortCourseDoc.client_content.voiceOptions = options;
        this.emitStatus();
    },
    
    onChangeCourseCardOptions: function(actionId, options) {
        action = { id: actionId, name: 'changeCourseCardOptions', options };
        shortCourseDoc.client_content.courseCard = options;
        this.emitStatus();
    },
    
    onChangePhraseData: function(actionId,phraseData) {
        action = { id: actionId, name: 'changePhraseData', phraseData };
        shortCourseDoc.client_content.phraseData = phraseData;
        this.emitStatus();
    },

    onSetDocBoilerplate: function(actionId, id, value) {
        action = { id: actionId, name: 'setDocBoilerplate', id, value };
        if ((value === null) || (typeof value === 'undefined')) {
            let doc_boilerplate = shortCourseDoc.client_content.doc_boilerplate;
            if (doc_boilerplate && doc_boilerplate[id]) {
                console.log(`clear doc_boilerplate ${id}`); // FIXME: remove debug spam
                delete doc_boilerplate[id];
                shortCourseDoc.client_content.doc_boilerplate = {...doc_boilerplate};
                this.emitStatus();
            }
            // else no change
        }
        else {
            let doc_boilerplate = shortCourseDoc.client_content.doc_boilerplate || {};
            if(doc_boilerplate[id] !== value) {
                console.log(`set doc_boilerplate ${id}`);  // FIXME: remove debug spam
                doc_boilerplate[id] = value;
                shortCourseDoc.client_content.doc_boilerplate = {...doc_boilerplate};
                this.emitStatus();
            }
            // else no change
        }
    },

    onImportClientContent: function(actionId, changes) {
        action = { id: actionId, name: 'importClientContent', changes };
        _.forEach(changes,(v,k)=>{
            switch(k) {
                case 'coach_scripts':
                case 'rich_texts':
                case 'coach_stickers':
                case 'phraseData':
                    shortCourseDoc.client_content[k] = v;
                    break;
                default:
                    console.log("importClientContent ignoring ",k);
            }
        });
        this.emitStatus();
    },
    
    onSetCurrentNavLoc: function(navLoc) {
        action = { id: null, name: 'setCurrentNavLoc', navLoc };
        currentNav = navLoc;
        this.emitStatus();
    },
    
    onGoToLocation: function(navLoc) {
        action = { id: null, name: 'goToLocation', navLoc };
        currentNav = { ...navLoc };
        switch(navLoc.type) {
            case ShortCourseConstants.NAV_TYPES.Settings:
            case ShortCourseConstants.NAV_TYPES.CoachScript:
            case ShortCourseConstants.NAV_TYPES.RichText:
                selectedNodeId = '';
                break;

            case ShortCourseConstants.NAV_TYPES.Node:
                selectedNodeId = navLoc.id;
                break;
                
            case ShortCourseConstants.NAV_TYPES.Comment:
                selectedCommentTopicID = navLoc.id;
                break;
        }
        this.emitStatus();
    },
    
    onSetSelectedCommentTopic: function(id) {
        action = { id: null, name: 'setSelectedCommentTopic', id };
        selectedCommentTopicID = id;
        this.emitStatus();
    },

    onSetNodeSearch: function(searchText) {
        action = { id: null, name: 'setNodeSearch', searchText };
        nodeSearchText = searchText;
        this.emitStatus();
    },

});

module.exports = ShortCourseEditorStore;